// extracted by mini-css-extract-plugin
export default {"column-resizer":"ColumnResizer_column-resizer__RQkDo"};